import React from "react";
import Bannerheader from "../pages/Bannerheader";
import { Footer } from "../navbar/Footer";

const PaymentPolicy = () => {
  return (
    <>
      <Bannerheader />

      {/* Document Style Container */}
      <div className="bg-light py-4">
        <div className="container">
          {/* Document Paper Effect */}
          <div className="bg-white shadow rounded-3 overflow-hidden">
            {/* Document Header */}
            <div className="border-bottom p-4 p-md-5 text-center bg-primary bg-opacity-10">
              <div className="mb-3">
                <span className="bg-primary text-white px-3 py-2 rounded-3 fw-semibold small">
                  FINANCIAL DOCUMENT
                </span>
              </div>
              <h1 className="display-5 fw-bold text-dark mb-2">
                PAYMENT POLICY
              </h1>
            </div>

            {/* Document Content */}
            <div className="p-4 p-md-5">
              {/* Introduction */}
              <div className="mb-5">
                <p className="lead text-secondary border-start border-primary border-4 ps-3 py-1">
                  This Payment Policy describes the payment methods, processing
                  procedures, and security measures implemented for all
                  transactions processed through our platform.
                </p>
              </div>

              {/* Payment Gateway Information */}
              <div className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "40px", height: "40px", flexShrink: 0 }}
                  >
                    <i className="bi bi-shield-check fs-5"></i>
                  </div>
                  <h2 className="h4 fw-bold mb-0">
                    Payment Processing Partner
                  </h2>
                </div>

                <div className="ps-md-5">
                  <div className="row align-items-center mb-4">
                    <div className="col-md-3 text-center text-md-start mb-3 mb-md-0">
                      <div className="bg-light p-3 rounded-3 d-inline-block">
                        <i className="bi bi-credit-card-2-front fs-1 text-primary"></i>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <h3 className="h5 fw-bold mb-2">
                        Razorpay Payment Gateway
                      </h3>
                      <p className="text-secondary mb-2">
                        We use Razorpay, a PCI-DSS compliant payment gateway, to
                        process all transactions securely. Razorpay is one of
                        India's leading payment solution providers, trusted by
                        millions of businesses.
                      </p>
                      <div className="d-flex flex-wrap gap-2 mt-3">
                        <span className="badge bg-light text-dark p-2">
                          <i className="bi bi-pci-card me-1 text-primary"></i>{" "}
                          PCI-DSS Compliant
                        </span>
                        <span className="badge bg-light text-dark p-2">
                          <i className="bi bi-lock-fill me-1 text-primary"></i>{" "}
                          256-bit SSL
                        </span>
                        <span className="badge bg-light text-dark p-2">
                          <i className="bi bi-check-circle-fill me-1 text-primary"></i>{" "}
                          3D Secure
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Accepted Payment Methods */}
              <div className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "40px", height: "40px", flexShrink: 0 }}
                  >
                    <i className="bi bi-wallet2 fs-5"></i>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Accepted Payment Methods</h2>
                </div>

                <div className="ps-md-5">
                  <p className="text-secondary mb-4">
                    We accept the following payment methods through our secure
                    Razorpay integration:
                  </p>

                  <div className="row g-3">
                    {/* Credit Card */}
                    <div className="col-md-6">
                      <div className="border rounded-3 p-3 h-100">
                        <div className="d-flex align-items-center mb-2">
                          <i className="bi bi-credit-card fs-3 text-primary me-2"></i>
                          <h4 className="h6 fw-bold mb-0">Credit Cards</h4>
                        </div>
                        <p className="small text-secondary mb-0">
                          Visa, MasterCard, American Express, Rupay
                        </p>
                      </div>
                    </div>

                    {/* Debit Card */}
                    <div className="col-md-6">
                      <div className="border rounded-3 p-3 h-100">
                        <div className="d-flex align-items-center mb-2">
                          <i className="bi bi-bank2 fs-3 text-primary me-2"></i>
                          <h4 className="h6 fw-bold mb-0">Debit Cards</h4>
                        </div>
                        <p className="small text-secondary mb-0">
                          All major bank debit cards (Visa, MasterCard, Rupay)
                        </p>
                      </div>
                    </div>

                    {/* Net Banking */}
                    <div className="col-md-6">
                      <div className="border rounded-3 p-3 h-100">
                        <div className="d-flex align-items-center mb-2">
                          <i className="bi bi-bank fs-3 text-primary me-2"></i>
                          <h4 className="h6 fw-bold mb-0">Net Banking</h4>
                        </div>
                        <p className="small text-secondary mb-0">
                          All major banks including SBI, HDFC, ICICI, Axis, and
                          more
                        </p>
                      </div>
                    </div>

                    {/* UPI */}
                    <div className="col-md-6">
                      <div className="border rounded-3 p-3 h-100">
                        <div className="d-flex align-items-center mb-2">
                          <i className="bi bi-phone fs-3 text-primary me-2"></i>
                          <h4 className="h6 fw-bold mb-0">UPI</h4>
                        </div>
                        <p className="small text-secondary mb-0">
                          Google Pay, PhonePe, Paytm, BHIM, and all UPI apps
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Payment Confirmation */}
              <div className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-info text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "40px", height: "40px", flexShrink: 0 }}
                  >
                    <i className="bi bi-check2-circle fs-5"></i>
                  </div>
                  <h2 className="h4 fw-bold mb-0">
                    Payment Confirmation Process
                  </h2>
                </div>

                <div className="ps-md-5">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="d-flex">
                        <div className="me-3">
                          <div
                            className="bg-success bg-opacity-10 text-success rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "32px", height: "32px" }}
                          >
                            1
                          </div>
                        </div>
                        <div>
                          <h5 className="h6 fw-bold">Immediate Confirmation</h5>
                          <p className="small text-secondary">
                            Upon successful payment, you'll receive an instant
                            confirmation on screen with your order ID.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex">
                        <div className="me-3">
                          <div
                            className="bg-success bg-opacity-10 text-success rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "32px", height: "32px" }}
                          >
                            2
                          </div>
                        </div>
                        <div>
                          <h5 className="h6 fw-bold">Email Confirmation</h5>
                          <p className="small text-secondary">
                            A detailed confirmation email with invoice will be
                            sent within 5-10 minutes.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex">
                        <div className="me-3">
                          <div
                            className="bg-success bg-opacity-10 text-success rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "32px", height: "32px" }}
                          >
                            3
                          </div>
                        </div>
                        <div>
                          <h5 className="h6 fw-bold">SMS Notification</h5>
                          <p className="small text-secondary">
                            You'll receive an SMS confirmation on your
                            registered mobile number.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex">
                        <div className="me-3">
                          <div
                            className="bg-success bg-opacity-10 text-success rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "32px", height: "32px" }}
                          >
                            4
                          </div>
                        </div>
                        <div>
                          <h5 className="h6 fw-bold">Order Summary</h5>
                          <p className="small text-secondary">
                            Complete order details including items, amount, and
                            delivery information.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Security Measures */}
              <div className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-warning text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "40px", height: "40px", flexShrink: 0 }}
                  >
                    <i className="bi bi-lock-fill fs-5"></i>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Payment Security</h2>
                </div>

                <div className="ps-md-5">
                  <div className="bg-light p-4 rounded-3">
                    <ul className="list-unstyled mb-0">
                      <li className="mb-3 d-flex">
                        <i className="bi bi-shield-check text-success me-3 fs-5"></i>
                        <div>
                          <strong className="d-block">
                            Encrypted Transactions
                          </strong>
                          <span className="small text-secondary">
                            All transactions are encrypted using 256-bit SSL
                            technology
                          </span>
                        </div>
                      </li>
                      <li className="mb-3 d-flex">
                        <i className="bi bi-database-slash text-success me-3 fs-5"></i>
                        <div>
                          <strong className="d-block">No Data Storage</strong>
                          <span className="small text-secondary">
                            We do not store any card or payment details on our
                            servers
                          </span>
                        </div>
                      </li>
                      <li className="mb-3 d-flex">
                        <i className="bi bi-shield text-success me-3 fs-5"></i>
                        <div>
                          <strong className="d-block">
                            3D Secure Authentication
                          </strong>
                          <span className="small text-secondary">
                            Additional security layer for card transactions
                          </span>
                        </div>
                      </li>
                      <li className="d-flex">
                        <i className="bi bi-pci-card text-success me-3 fs-5"></i>
                        <div>
                          <strong className="d-block">
                            PCI-DSS Compliance
                          </strong>
                          <span className="small text-secondary">
                            We adhere to the highest security standards
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Failed Transactions */}
              <div className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "40px", height: "40px", flexShrink: 0 }}
                  >
                    <i className="bi bi-exclamation-triangle fs-5"></i>
                  </div>
                  <h2 className="h4 fw-bold mb-0">
                    Failed Transactions & Refunds
                  </h2>
                </div>

                <div className="ps-md-5">
                  <div className="row">
                    <div className="col-md-7">
                      <p className="text-secondary mb-3">
                        If your payment fails but the amount has been debited
                        from your account:
                      </p>
                      <ul className="text-secondary">
                        <li className="mb-2">
                          The amount will be automatically refunded to your
                          source account
                        </li>
                        <li className="mb-2">
                          Refund processing time: 5-7 business days
                        </li>
                        <li className="mb-2">
                          You will receive a refund confirmation email
                        </li>
                        <li className="mb-2">
                          Contact support if refund not received within 10 days
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-5">
                      <div className="bg-danger bg-opacity-10 p-3 rounded-3">
                        <h6 className="fw-bold mb-2">Important:</h6>
                        <small className="text-danger">
                          <i className="bi bi-clock-history me-1"></i>
                          Refund timelines may vary based on your bank's
                          processing time.
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Terms & Conditions */}
              <div className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "40px", height: "40px", flexShrink: 0 }}
                  >
                    <i className="bi bi-file-text fs-5"></i>
                  </div>
                  <h2 className="h4 fw-bold mb-0">
                    Payment Terms & Conditions
                  </h2>
                </div>

                <div className="ps-md-5">
                  <div className="border rounded-3 p-4">
                    <ol
                      className="mb-0 text-secondary"
                      style={{ paddingLeft: "1rem" }}
                    >
                      <li className="mb-2">
                        All payments are processed in Indian Rupees (INR)
                      </li>
                      <li className="mb-2">
                        International cards may incur additional foreign
                        transaction fees
                      </li>
                      <li className="mb-2">
                        Maximum transaction limit: ₹2,00,000 per order
                      </li>
                      <li className="mb-2">
                        We reserve the right to cancel orders in case of
                        suspected fraud
                      </li>
                      <li className="mb-2">
                        Payment receipt serves as proof of transaction
                      </li>
                      <li className="mb-2">
                        GST invoice will be generated for all successful
                        payments
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bootstrap Icons */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
      />

      <Footer />
    </>
  );
};

export default PaymentPolicy;
